import axios from 'axios'
import { Urls } from '../../urls'
import { ServiceUrls } from '../../serviceUrls'

export const getManagePredictorToolsFilterData = (params) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'GET',
    url: Urls.GET_MANAGE_PREDICTOR_TOOLS_FILTER_API,
    params: params,
  })
}

export const getPredictorToolsListingData = (params) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'GET',
    url: Urls.GET_MANAGE_PREDICTOR_TOOLS_FILTER_Listing_API,
    params: params,
  })
}

export const getBasicDetailsDropdownList = (params) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'GET',
    url: Urls.GET_MANAGE_PREDICTOR_TOOLS_BASIC_DETAIL_DROPDOWNLIST,
    params: params,
  })
}

export const getBasicToolsDetailsRepo = (params) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'GET',
    url: Urls.MANAGE_PREDICTOR_TOOLS_BASIC_DETAIL_API,
    params: params,
  })
}

export const postBasicToolsDetailsRepo = (data) => {
  console.log(",,,data", data)
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'POST',
    url: Urls.MANAGE_PREDICTOR_TOOLS_BASIC_DETAIL_API,
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

//input detail page
export const getInputPageDetailRepo = (params) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'GET',
    url: Urls.GET_PREDICTOR_INPUT_PAGE_DETAIL,
    params: params,
  })
}
export const postInputPageDetailRepo = (data) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'POST',
    url: Urls.GET_PREDICTOR_INPUT_PAGE_DETAIL,
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

//input page tool content
export const getInputPageToolContentRepo = (params) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'GET',
    url: Urls.GET_PREDICTOR_INPUT_PAGE_TOOL_CONTENT,
    params: params,
  })
}
export const postInputPageToolContentRepo = (data) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'POST',
    url: Urls.GET_PREDICTOR_INPUT_PAGE_TOOL_CONTENT,
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

//input page faq content
export const getInputPageFaqContentRepo = (params) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'GET',
    url: Urls.GET_PREDICTOR_INPUT_PAGE_FAQ,
    params: params,
  })
}
export const postInputPageFaqContentRepo = (data) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'POST',
    url: Urls.GET_PREDICTOR_INPUT_PAGE_FAQ,
    data: data,
  })
}

//manage result page
export const getResultPageRepo = (params) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'GET',
    url: Urls.GET_PREDICTOR_MANAGE_RESULT_PAGE,
    params: params,
  })
}
export const postResultPageRepo = (data) => {
  return axios({
    baseURL:ServiceUrls.TOOLSHUB_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'POST',
    url: Urls.GET_PREDICTOR_MANAGE_RESULT_PAGE,
    data: data,
  })
}

